import { v4 as uuidv4 } from "uuid";
import {
    RpServiceConfigurationPolicyConfigDecisionCondition,
    FormattedRpServiceConfigurationPolicyConfigDecisionCondition
} from "@idw-types/data/rp-service-configuration";
import { AxnAttributeTypeField } from "@idw-types/data/reference-data/axn";
import { DeployedPolicyComponent } from "@idw-types/data/reference-data/generic";

export const formatRpServiceConfigurationPolicyConfigDecisionConditions = (
    conditions: Array<RpServiceConfigurationPolicyConfigDecisionCondition>,
    deployedPolicyComponents: Array<DeployedPolicyComponent>,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>
): Array<FormattedRpServiceConfigurationPolicyConfigDecisionCondition> => {
    return conditions.map(condition => formatRpServiceConfigurationPolicyConfigDecisionCondition(condition, deployedPolicyComponents, axnAttributeTypeFields));
};

export const formatRpServiceConfigurationPolicyConfigDecisionCondition = (
    condition: RpServiceConfigurationPolicyConfigDecisionCondition,
    deployedPolicyComponents: Array<DeployedPolicyComponent>,
    axnAttributeTypeFields: Array<AxnAttributeTypeField>
): FormattedRpServiceConfigurationPolicyConfigDecisionCondition => {
    let component = null;
    if (condition.componentID) {
        component = deployedPolicyComponents.find(dpc => dpc.id === condition.componentID);
    }

    let attributeField = null;
    if (condition.attributeFieldID) {
        attributeField = axnAttributeTypeFields.find(atf => atf.id === condition.attributeFieldID);
    }

    return {
        assertionID: condition.assertionID,
        attributeField: attributeField,
        component: component,
        description: condition.description,
        id: condition.id,
        policyConditionOperator: condition.policyConditionOperator,
        result: condition.result,
        serviceOfferingID: condition.serviceOfferingID,
        attributeFieldCategory: condition.attributeFieldCategory,
        attributeField2ID: condition.attributeField2ID,
        attributeField2Category: condition.attributeField2Category,
        step: condition.step,
        step2: condition.step2,
        uuid: uuidv4(),
        values: condition.values
    };
};